module.exports = __webpack_public_path__ + "static/img/pic-02@2x.9481d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-02@2x.png
// module id = zKOH
// module chunks = 1